module.exports = __webpack_public_path__ + "img/person4.3a15e1fd.svg";